export default __webpack_public_path__ + "static/media/consultation.f48ecc27.gif";